<template>
  <div>
    <!--v-show="show"-->
    <div align="right">
      <el-form :inline="true" class="style1">
        <el-form-item>
          <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">
            {{$t("general.add")}}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px" :empty-text="$t('general.empty_data')">

      <el-table-column :label="$t('general.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>

      <el-table-column　:label="$t('companyInfo.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.comName }}</span>
        </template>
      </el-table-column>

      <el-table-column　:label="$t('empList.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.empName }}</span>
        </template>
      </el-table-column>

      <el-table-column　label="介護休業開始年月日" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.nursingStartDate }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" width="360">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}
          </el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}
          </el-button>
          <el-button size="mini" type="success" icon="el-icon-view" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- adding new -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="69%" :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="9rem" class="demo-inputForm" size="medium" :label-position="labelPosition" style="width: 94%; margin-left: 3%; margin-right: 3%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('general.date')+':'" prop="date">
              <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
              <el-select v-model="inputForm.company_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="事業主確認日:">
              <el-date-picker v-model="inputForm.confirmDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('general.employee_id') + ':'" prop="empID">
              <el-select v-model="inputForm.empID" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;" @change="getFamilyList(inputForm.empID)">
                <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item :label="$t('empList.name') + ':'" prop="empID">
              <el-select v-model="inputForm.empID" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;" @change="getFamilyList(inputForm.empID)">
                <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item label="介護対象家族の姓名:" prop="familyID">
              <el-select v-model="inputForm.familyID" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in familyList" :key="item.id" :label="item.name_family" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="介護休業開始日:">
              <el-date-picker v-model="inputForm.nursingStartDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-form-item label="備考:">
            <el-input v-model="inputForm.remark" size=mini prefix-icon="el-icon-edit"></el-input>
          </el-form-item>

        </el-row>

        <el-form-item label="その１：" label-width="5rem">
          <div class="borderBox">
            <el-row>
              <el-form-item label="支給対象期間:" label-width="7rem">
                <el-date-picker v-model="inputForm.paymentStart1" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
                ～
                <el-date-picker v-model="inputForm.paymentEnd1" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
              </el-form-item>
            </el-row>

            <el-row :gutter=30>
              <el-col :md=10>
                <el-form-item label="全日休業日数:" label-width="7rem">
                  <el-input-number v-model="inputForm.leaveDay1" size=mini controls-position="right" :min="0" style="width: 100%;" :step="5"></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :md=14>
                <el-form-item label="支払われた賃金額:">
                  <el-input-number v-model="inputForm.payment1" size=mini controls-position="right" :min="0" :step="1000" style="width: 80%;"></el-input-number>円
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="その２：" label-width="5rem">
          <div class="borderBox">
            <el-row>
              <el-form-item label="支給対象期間:" label-width="7rem">
                <el-date-picker v-model="inputForm.paymentStart2" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
                ～
                <el-date-picker v-model="inputForm.paymentEnd2" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
              </el-form-item>
            </el-row>

            <el-row :gutter=30>
              <el-col :md=10>
                <el-form-item label="全日休業日数:" label-width="7rem">
                  <el-input-number v-model="inputForm.leaveDay2" size=mini controls-position="right" :min="0" style="width: 100%;" :step="5"></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :md=14>
                <el-form-item label="支払われた賃金額:">
                  <el-input-number v-model="inputForm.payment2" size=mini controls-position="right" :min="0" :step="1000" style="width: 80%;"></el-input-number>円
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="その３：" label-width="5rem">
          <div class="borderBox">
            <el-row>
              <el-form-item label="支給対象期間:" label-width="7rem">
                <el-date-picker v-model="inputForm.paymentStart3" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
                ～
                <el-date-picker v-model="inputForm.paymentEnd3" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
              </el-form-item>
            </el-row>

            <el-row :gutter=30>
              <el-col :md=10>
                <el-form-item label="全日休業日数:" label-width="7rem">
                  <el-input-number v-model="inputForm.leaveDay3" size=mini controls-position="right" :min="0" style="width: 100%;" :step="5"></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :md=14>
                <el-form-item label="支払われた賃金額:">
                  <el-input-number v-model="inputForm.payment3" size=mini controls-position="right" :min="0" :step="1000" style="width: 80%;"></el-input-number>円
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="介護休業終了:">
          <div class="borderBox">
            <el-row :gutter=20>
              <el-col :md=12>
                <el-form-item label="年月日:" label-width="4rem">
                  <el-date-picker v-model="inputForm.nursingEndDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
                  </el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :md=12>
                <el-form-item label="事由:" label-width="4rem">
                  <el-select v-model="inputForm.endReason" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                    <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="add('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <!-- edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogEdit" width="69%" :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="9rem" class="demo-inputForm" size="medium" :label-position="labelPosition" style="width: 94%; margin-left: 3%; margin-right: 3%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('general.date')+':'" prop="date">
              <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
              <el-select v-model="inputForm.company_id" size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id" disabled>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="事業主確認日:">
              <el-date-picker v-model="inputForm.confirmDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('general.employee_id') + ':'" prop="empID">
              <el-select v-model="inputForm.empID" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;" @change="getFamilyList(inputForm.empID)">
                <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item :label="$t('empList.name') + ':'" prop="empID">
              <el-select v-model="inputForm.empID" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;" @change="getFamilyList(inputForm.empID)">
                <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item label="介護対象家族の姓名:" prop="familyID">
              <el-select v-model="inputForm.familyID" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in familyList" :key="item.id" :label="item.name_family" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="介護休業開始日:">
              <el-date-picker v-model="inputForm.nursingStartDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-form-item label="備考:">
            <el-input v-model="inputForm.remark" size=mini prefix-icon="el-icon-edit"></el-input>
          </el-form-item>

        </el-row>

        <el-form-item label="その１：" label-width="5rem">
          <div class="borderBox">
            <el-row>
              <el-form-item label="支給対象期間:" label-width="7rem">
                <el-date-picker v-model="inputForm.paymentStart1" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
                ～
                <el-date-picker v-model="inputForm.paymentEnd1" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
              </el-form-item>
            </el-row>

            <el-row :gutter=30>
              <el-col :md=10>
                <el-form-item label="全日休業日数:" label-width="7rem">
                  <el-input-number v-model="inputForm.leaveDay1" size=mini controls-position="right" :min="0" style="width: 100%;" :step="5"></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :md=14>
                <el-form-item label="支払われた賃金額:">
                  <el-input-number v-model="inputForm.payment1" size=mini controls-position="right" :min="0" :step="1000" style="width: 80%;"></el-input-number>円
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="その２：" label-width="5rem">
          <div class="borderBox">
            <el-row>
              <el-form-item label="支給対象期間:" label-width="7rem">
                <el-date-picker v-model="inputForm.paymentStart2" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
                ～
                <el-date-picker v-model="inputForm.paymentEnd2" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
              </el-form-item>
            </el-row>

            <el-row :gutter=30>
              <el-col :md=10>
                <el-form-item label="全日休業日数:" label-width="7rem">
                  <el-input-number v-model="inputForm.leaveDay2" size=mini controls-position="right" :min="0" style="width: 100%;" :step="5"></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :md=14>
                <el-form-item label="支払われた賃金額:">
                  <el-input-number v-model="inputForm.payment2" size=mini controls-position="right" :min="0" :step="1000" style="width: 80%;"></el-input-number>円
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="その３：" label-width="5rem">
          <div class="borderBox">
            <el-row>
              <el-form-item label="支給対象期間:" label-width="7rem">
                <el-date-picker v-model="inputForm.paymentStart3" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
                ～
                <el-date-picker v-model="inputForm.paymentEnd3" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%" :placeholder="$t('general.please_select')">
                </el-date-picker>
              </el-form-item>
            </el-row>

            <el-row :gutter=30>
              <el-col :md=10>
                <el-form-item label="全日休業日数:" label-width="7rem">
                  <el-input-number v-model="inputForm.leaveDay3" size=mini controls-position="right" :min="0" style="width: 100%;" :step="5"></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :md=14>
                <el-form-item label="支払われた賃金額:">
                  <el-input-number v-model="inputForm.payment3" size=mini controls-position="right" :min="0" :step="1000" style="width: 80%;"></el-input-number>円
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="介護休業終了:">
          <div class="borderBox">
            <el-row :gutter=20>
              <el-col :md=12>
                <el-form-item label="年月日:" label-width="4rem">
                  <el-date-picker v-model="inputForm.nursingEndDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
                  </el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :md=12>
                <el-form-item label="事由:" label-width="4rem">
                  <el-select v-model="inputForm.endReason" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                    <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="edit('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {

  data() {

    return {
      pageSize: 6,
      currentPage: 1,
      total: 0,
      disablePage: false,

      labelPosition: "left",

      dialogVisible: false,
      dialogEdit: false,

      tableData: [],
      companyInfo: [],
      empList: [],
      familyList: [],

      inputForm: {
        id: "",
        company_id: "",
        empID: "",
        familyID: "",
        confirmDate: "",
        date: "",

        paymentStart1: "",
        paymentEnd1: "",
        leaveDay1: "",
        payment1: "",

        paymentStart2: "",
        paymentEnd2: "",
        leaveDay2: "",
        payment2: "",

        paymentStart3: "",
        paymentEnd3: "",
        leaveDay3: "",
        payment3: "",

        nursingStartDate: "",
        nursingEndDate: "",
        endReason: "",

        remark: ""
      },

      rules: {
        familyID: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        date: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        company_id: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        empID: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
      },

      reason: [{
        value: "1",
        label: "職場復帰",
      }, {
        value: "2",
        label: "休業事由の消滅",
      },],
    };
  },
  methods: {

    preview(row) {
      //   var uid = window.localStorage.getItem('LoginUserId');
      window.open(
        "/pdf/介護休業給付金支給申請書-" + row.empName + row.date + ".pdf"
      );
    },

    printPDF(index, row) {
      let postData = this.qs.stringify({
        id: row.id
      });
      this.axios({
        method: "post",
        url: "/empInsNursingLeavePDF",
        data: postData
      })
        .then((response) => {
          console.log(response)
          if (response.data.status = "success") {
            this.$message({
              type: "success",
              message: this.$t("general.print_completed")
            });
            setTimeout(() => {
              this.preview(row);
            }, 300);
          } else {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed")
            });
          }
        })
        .catch(error => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed")
          });
          // console.log(error);
        });
    },


    add(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            company_id: this.inputForm.company_id,

            empID: this.inputForm.empID,
            familyID: this.inputForm.familyID,
            confirmDate: this.inputForm.confirmDate,
            date: this.inputForm.date,

            paymentStart1: this.inputForm.paymentStart1,
            paymentEnd1: this.inputForm.paymentEnd1,
            leaveDay1: this.inputForm.leaveDay1,
            payment1: this.inputForm.payment1,

            paymentStart2: this.inputForm.paymentStart2,
            paymentEnd2: this.inputForm.paymentEnd2,
            leaveDay2: this.inputForm.leaveDay2,
            payment2: this.inputForm.payment2,

            paymentStart3: this.inputForm.paymentStart3,
            paymentEnd3: this.inputForm.paymentEnd3,
            leaveDay3: this.inputForm.leaveDay3,
            payment3: this.inputForm.payment3,

            nursingStartDate: this.inputForm.nursingStartDate,
            nursingEndDate: this.inputForm.nursingEndDate,
            endReason: this.inputForm.endReason,


            remark: this.inputForm.remark
          });
          this.axios({
            method: "post",
            url: "/insertEmpInsNursingLeave",
            data: postData
          })
            .then(response => {
              this.$message({
                type: "success",
                message: this.$t("general.add_completed")
              });
              this.currentPage = 1;
              this.getPages();
              this.dialogVisible = false;
              this.emptyForm();
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.add_failed")
              });
              console.log(error);
            });
        } else {
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleEdit(index, row) {
      this.dialogEdit = true;
      this.inputForm = Object.assign({}, row);
    },

    edit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.inputForm.id,

            empID: this.inputForm.empID,
            familyID: this.inputForm.familyID,
            confirmDate: this.inputForm.confirmDate,
            date: this.inputForm.date,

            paymentStart1: this.inputForm.paymentStart1,
            paymentEnd1: this.inputForm.paymentEnd1,
            leaveDay1: this.inputForm.leaveDay1,
            payment1: this.inputForm.payment1,

            paymentStart2: this.inputForm.paymentStart2,
            paymentEnd2: this.inputForm.paymentEnd2,
            leaveDay2: this.inputForm.leaveDay2,
            payment2: this.inputForm.payment2,

            paymentStart3: this.inputForm.paymentStart3,
            paymentEnd3: this.inputForm.paymentEnd3,
            leaveDay3: this.inputForm.leaveDay3,
            payment3: this.inputForm.payment3,

            nursingStartDate: this.inputForm.nursingStartDate,
            nursingEndDate: this.inputForm.nursingEndDate,
            endReason: this.inputForm.endReason,

            remark: this.inputForm.remark
          });
          this.axios({
            method: "post",
            url: "/updateEmpInsNursingLeave",
            data: postData
          })
            .then(response => {
              this.handleCurrentChange();
              this.dialogEdit = false;
              this.emptyForm();
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed")
              });
              // console.log(response);
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed")
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id
          });
          this.axios({
            method: "post",
            url: "/deleteEmpInsNursingLeave",
            data: postData
          })
            .then(response => {
              this.getPages();
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed")
              });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled")
          });
        });
    },

    jump(path) {
      this.$router.push(path);
    },

    cancel() {
      this.dialogVisible = false;
      this.dialogEdit = false;
      this.emptyForm();
    },

    emptyForm() {
      this.inputForm = {
        id: "",
        company_id: "",
        empID: "",
        familyID: "",
        confirmDate: "",
        date: "",

        paymentStart1: "",
        paymentEnd1: "",
        leaveDay1: "",
        payment1: "",

        paymentStart2: "",
        paymentEnd2: "",
        leaveDay2: "",
        payment2: "",

        paymentStart3: "",
        paymentEnd3: "",
        leaveDay3: "",
        payment3: "",

        nursingStartDate: "",
        nursingEndDate: "",
        endReason: "",

        remark: ""
      }
      this.$refs['inputForm'].resetFields();
    },

    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(_ => {
          done();
          this.emptyForm();
        })
        .catch(_ => { });
    },

    handleCurrentChange() {
      let postData = this.qs.stringify({
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/pageEmpInsNursingLeave",
        data: postData
      })
        .then(response => {
          this.tableData = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getFamilyList(eid) {
      console.log(eid)
      this.inputForm.familyID = ""

      let postData = this.qs.stringify({
        eid: eid,
      });
      this.axios({
        method: "post",
        url: "/listFamilyByEid",
        data: postData,
      })
        .then(response => {
          this.familyList = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getPages() {
      this.axios
        .post("/pageEmpInsNursingLeave")
        .then(response => {
          this.show = true
          this.tableData = response.data;
        })
        .catch(error => {
          this.show = false;
          this.$message({
            type: 'error',
            message: '開発中です。'
          });
          console.log(error);
        });
      this.axios
        .post("/rowsEmpInsNursingLeave")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
  },

  created() {
    this.getPages();

    //get Company List
    this.axios
      .post("/ListComInfo")
      .then((response) => {
        this.companyInfo = response.data;
        console.log(this.companyInfo);
      })
      .catch((error) => {
        console.log(error);
      });

    //get Employee Name
    this.axios
      .post("/ListEmpListForInsNameChange")
      .then(response => {
        this.empList = response.data;
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style scoped>
.style1 {
  margin-right: 100px;
  padding: 0px;
  text-align: right;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}

.borderBox {
  background-color: #eff0f0a6;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  /* border: rgb(204, 204, 204) 1px solid; */
  padding: 2%;
}

.boxHeader {
  font-size: large;
  font-weight: bold;
  font-family: Microsoft YaHei;
  letter-spacing: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpInsNursingLeave.vue